import { useContext, useState } from 'react';
import PageContext from './PageContext';
import CCOffcanvas from './CCOffcanvas.tsx';
import ButtonComponent from './ButtonComponent.jsx';
import ApiRequestButton from './ApiRequestButton.jsx';
import ClientProfileWorkflowCommentLog from './ClientProfileWorkflowCommentLog.jsx';
import EllipsisInfoLabel from './EllipsisInfoLabel.jsx';
import { HttpContext } from '../../api-services/HttpService';
import '../../css/offcanvasStyle.css';

const ClientProfileWorkflowCommentModal = () => {
    const {
        commentModal,
        setCommentModal,
        auditRow,
        snackbarAlert,
    } = useContext(PageContext);

    const { POST } = useContext(HttpContext);

    const [commentText, setCommentText] = useState('');
    // key to force re-render of comment log after new comment submitted
    const [commentLogKey, setCommentLogKey] = useState(0);

    const handleClose = () => {
        setCommentText('');
        setCommentModal(false);
    };

    const onSubmitClick = () => {
        return new Promise((resolve, reject) => {
            if (!commentText || commentText.trim() === '') {
                snackbarAlert(true, 'Please enter a comment.', 'error');
                reject();
                return;
            }
            POST('/client/clientProfileWorkflow/comments', {
                workflowid: auditRow['workflowid'],
                commenttext: commentText.trim(),
                commenttype: 'Comment'
            }).then(res => {
                console.log(res);
                setCommentText('');
                // re-fetch comment log by changing key
                setCommentLogKey(prev => prev + 1);
                snackbarAlert(true, 'Comment submitted successfully.', 'success');
                resolve(res);
            }).catch(err => {
                console.log(err);
                snackbarAlert(true, 'Error submitting comment.', 'error');
                reject(err);
            });
        });
    };

    if (!auditRow) return null;

    return (
        <CCOffcanvas
            title="Comment Log"
            show={commentModal}
            onCanvasClose={handleClose}
            bodyCssClassName="offcanvas-body"
            offCanvasClassName="offcanvas-parent-card"
        >
            {/* company info header */}
            <div className="bg-white p-3" style={{ fontSize: '14px' }}>
                <div className="d-flex gap-3 flex-wrap">
                    <EllipsisInfoLabel title="Master Company:" content={auditRow['mastercompanyname']} maxChar="50" />
                    <div className="vr"></div>
                    <EllipsisInfoLabel title="Company:" content={auditRow['companyname']} maxChar="50" />
                    <div className="vr"></div>
                    <EllipsisInfoLabel title="Status:" content={auditRow['status']} maxChar="20" />
                </div>
            </div>
            {/* comment log + new comment input */}
            <div className="p-3 comment-section">
                <div className="bg-white comment-card">
                    <ClientProfileWorkflowCommentLog key={commentLogKey} workflowid={auditRow['workflowid']} />
                    {/* new comment input */}
                    <div className="p-3" style={{ borderTop: '1px solid #ECECEC' }}>
                        <input
                            className="w-100 input-text-field"
                            value={commentText}
                            onChange={(e) => setCommentText(e.target.value)}
                            placeholder="Type comments here"
                        />
                    </div>
                </div>
            </div>
            <div className="d-flex justify-content-end p-3 w-100 position-absolute bottom-0 offcanvas-footer">
                <ButtonComponent
                    tag="Cancel"
                    border="#fcd800 1px solid"
                    background="#fff"
                    color="#001317"
                    onButtonClick={handleClose}
                />
                <ApiRequestButton onButtonClick={onSubmitClick} tag="Submit" />
            </div>
        </CCOffcanvas>
    );
};

export default ClientProfileWorkflowCommentModal;
